const pillars = [
  {
    icon: 'ri-price-tag-3-line',
    title: 'No Booking, No Fee',
    description:
      'You pay nothing until a guest books your villa. There are zero upfront costs, zero monthly charges and zero listing fees. Our success is tied entirely to yours.',
  },
  {
    icon: 'ri-eye-line',
    title: 'Just More Visibility',
    description:
      'Think of PadelVillas as an additional showcase for your property, putting it in front of exactly the right audience without displacing anything you already have in place.',
  },
  {
    icon: 'ri-door-open-line',
    title: 'No Lock-In',
    description:
      'You remain fully in control. List when it suits you, pause when it does not. There are no contracts tying you in and no penalties for stepping back.',
  },
];

export default function ZeroRisk() {
  return (
    <section className="py-20 bg-[#2C2C2C]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="font-inter text-xs text-[#D4845C] uppercase tracking-[0.2em] font-medium mb-5">
            Owner Assurance
          </p>
          <h2 className="font-cormorant text-5xl lg:text-6xl font-light text-white leading-[1.1]">
            Zero Risk.<br />
            <em className="italic text-[#D4845C]">Nothing to Lose.</em>
          </h2>
          <p className="font-inter font-light text-white/60 text-base max-w-xl mx-auto mt-6 leading-relaxed">
            Listing your villa with PadelVillas costs you nothing. It simply means the right people, high-net-worth padel travellers, can find you.
          </p>
        </div>

        {/* Pillars */}
        <div className="grid md:grid-cols-3 gap-px bg-white/10 rounded-2xl overflow-hidden">
          {pillars.map((p) => (
            <div key={p.title} className="bg-[#2C2C2C] px-10 py-12 flex flex-col gap-5">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#D4845C]/15">
                <i className={`${p.icon} text-xl text-[#D4845C]`} />
              </div>
              <h3 className="font-cormorant text-2xl font-semibold text-white">{p.title}</h3>
              <p className="font-inter font-light text-white/60 text-sm leading-relaxed">{p.description}</p>
            </div>
          ))}
        </div>

        {/* Bottom line */}
        <p className="text-center font-inter font-light text-white/40 text-xs uppercase tracking-widest mt-10">
          No upfront fees &nbsp;&middot;&nbsp; No hidden charges &nbsp;&middot;&nbsp; No obligation
        </p>
      </div>
    </section>
  );
}